export const getBrowserLanguage = () => navigator && navigator.languages ? navigator.languages[0] : navigator.language;